import { decrypt } from "../../../../utils/encodingdecoding";
import { starblazeMerchantId } from "../../../../utils";

export const getColumns = (withCustomer = false) => {
    const merchantCode = localStorage.getItem("Id");
    const isSuperonMerchant =
        decrypt(merchantCode) === starblazeMerchantId;

    return [
        withCustomer
            ? {
                Header: "QR Code",
                Footer: "QR Code",
                accessor: "code",
            }
            : {
                Header: "QR Code",
                Footer: "QR Code",
                accessor: "encryptCode",
            },
        ...(withCustomer
            ? [{
                Header: "Customer Name",
                Footer: "Customer Name",
                accessor: "customerName",
            }]
            : []),
        {
            Header: "Created Date",
            Footer: "Created Date",
            accessor: "createddate",
        },
        ...(isSuperonMerchant
            ? [{
                Header: "Scan Date",
                Footer: "Scan Date",
                accessor: "scandate",
            }]
            : []),
        {
            Header: "Scan Action",
            Footer: "Scan Action",
            accessor: "status",
        },
    ]
};
